import React from 'react';
import { styled } from '@mui/material/styles';
import {
  Avatar,
  Grid,
  List,
  ListItem,
  ListItemAvatar,
  ListItemSecondaryAction,
  ListItemText,
  Typography,
  Box,
  Divider
} from '@mui/material';
import { FiberManualRecord } from '@mui/icons-material';
import moment from 'moment';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
import NotificationsIcon from '@mui/icons-material/Notifications';
import { getApplicationById } from '../../api/Applications';
import { decryptData } from '../../utils/helper';
import { useDispatch, useSelector } from 'react-redux';
import { failed } from '../../utils/Tostify';


const ListItemWrapper = styled('div')(({ theme }) => ({
  cursor: 'pointer',
  padding: 16,
  '&:hover': {
    background: theme.palette.primary.light
  },
  '& .MuiListItem-root': {
    padding: 0
  }
}));


const NotificationList = ({ notifications = [] }) => {
  const dispatch  = useDispatch();
  let token = useSelector((state) => state.userReducer.token);
  const navigate = useNavigate();

  const today = moment().startOf('day');
  const todayNotis = notifications.filter(noti =>
    moment(noti?.createdAt).isSame(today, 'd')
  );
  const olderNotis = notifications.filter(noti =>
    !moment(noti?.createdAt).isSame(today, 'd')
  );

  const handleLinkClick = async (e, linkInfo) => {
    const path = linkInfo.Link;
    const stateId = linkInfo.state?.$oid || linkInfo.state;

    if (path === '/app/application-detail') {
      e.preventDefault();
      try {
        const res = await getApplicationById({ dispatch, token, applicationId: stateId });
        const responseData = decryptData(res?.data);
        if (res?.status === "SUCCESS") {
          navigate(path, {
            state: {
              applicationId: stateId,
              applicationData: responseData
            }
          });
        } else {
          failed(res?.message);
        }
      } catch (error) {
        failed("Something went wrong");
      }
    }
  };

  const renderMessageWithLinks = (message, linkArray = []) => {
    if (!linkArray.length) return <span>{message}</span>;

    const sortedLinks = [...linkArray].sort((a, b) => b.Text.length - a.Text.length);
    const linkMap = new Map(sortedLinks.map(link => [link.Text, link]));
    const escapedTexts = sortedLinks.map(({ Text }) =>
      Text.replace(/[-[\]/{}()*+?.\\^$|]/g, '\\$&')
    );
    const regex = new RegExp(`(${escapedTexts.join('|')})`, 'g');

    const parts = [];
    let lastIndex = 0;

    message.replace(regex, (match, p1, offset) => {
      if (offset > lastIndex) parts.push(message.slice(lastIndex, offset));
      const linkInfo = linkMap.get(match);
      parts.push(
        <RouterLink
          key={`${match}-${offset}`}
          to={linkInfo.Link}
          state={{ id: linkInfo.state?.$oid || linkInfo.state }}
          onClick={(e) => handleLinkClick(e, linkInfo)}
          style={{ textDecoration: 'underline', color: '#1976d2' }}
        >
          {match}
        </RouterLink>
      );
      lastIndex = offset + match.length;
      return match;
    });

    if (lastIndex < message.length) parts.push(message.slice(lastIndex));

    return <span>{parts}</span>;
  };


  const renderSection = (title, notiList) => (
    <>
      <Typography
        variant="h6"
        sx={{ px: 2, pt: 1, pb: 1, color: 'text.secondary' }}
      >
        {title}
      </Typography>
      {notiList.map((noti, index) => (
        <React.Fragment key={noti?._id}>
          <ListItemWrapper>
            <ListItem alignItems="center">
            <ListItemAvatar>
                <Avatar sx={{ bgcolor: '#9da39e' }}>
                  <NotificationsIcon sx={{ fontSize: 20 }} />
                </Avatar>
              </ListItemAvatar>
              <ListItemText primary={noti?.title} />
              <ListItemSecondaryAction>
                {!noti?.isRead && (
                  <FiberManualRecord sx={{ color: '#1976d2', fontSize: 12 }} />
                )}
              </ListItemSecondaryAction>
            </ListItem>
            <Grid container direction="column" className="list-container">
              <Grid item xs={12} sx={{ pb: 2 }}>
                <Typography
                  variant="subtitle2"
                  component="span"
                  sx={{
                    wordBreak: 'break-word',
                    whiteSpace: 'normal',
                    display: 'inline'
                  }}
                >
                  {renderMessageWithLinks(noti?.message, noti?.linkArray)}
                </Typography>
              </Grid>
            </Grid>
          </ListItemWrapper>
          <Divider sx={{ mx: 2, backgroundColor: 'grey.500', height: '0.5px' }} />
        </React.Fragment>
      ))}
    </>
  );

  if (notifications.length === 0) {
    return (
      <Typography variant="body2" sx={{ padding: 2 }}>
        No notifications
      </Typography>
    );
  }

  return (
    <Box sx={{ height: '100%', maxHeight: '500px',overflowY: 'auto' }}>
      <List sx={{ paddingTop: 0 }}>
        {todayNotis.length > 0 && renderSection('Today', todayNotis)}
        {olderNotis.length > 0 && renderSection('Older', olderNotis)}
      </List>
    </Box>
  );
};

export default NotificationList;


